var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"vue-badge",class:{'alternative': _vm.alternative}},[_vm._t("default"),_vm._v("\n\n    "+_vm._s(_vm.label)+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }